var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      (_vm.list && _vm.list.length) || _vm.loading
        ? _c("div", { staticClass: "table-wrapper" }, [
            _c("table", { staticClass: "table" }, [
              _vm._m(0),
              _vm.list
                ? _c(
                    "tbody",
                    _vm._l(_vm.list, function(category) {
                      return _c("tr", { key: category.id }, [
                        _c("td", [_vm._v(" " + _vm._s(category.name) + " ")]),
                        _c(
                          "td",
                          { staticClass: "text-center" },
                          [
                            category.sites_count
                              ? _c(
                                  "router-link",
                                  {
                                    staticClass: "external-link",
                                    attrs: {
                                      to: {
                                        name: "NetworkSites",
                                        params: { category_id: category.id }
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(category.sites_count) + " "
                                    ),
                                    _c("i", {
                                      staticClass: "fas fa-external-link-alt"
                                    })
                                  ]
                                )
                              : _c("div", [
                                  _vm._v(
                                    " " + _vm._s(category.sites_count) + " "
                                  )
                                ])
                          ],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticClass:
                              "fixed-right-column table__action-column"
                          },
                          [
                            _c(
                              "el-button-group",
                              [
                                _c("el-button", {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    icon: "el-icon-edit",
                                    title: "Edit"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleEdit(category)
                                    }
                                  }
                                }),
                                _c("el-button", {
                                  attrs: {
                                    type: "danger",
                                    size: "mini",
                                    title: "Delete",
                                    icon: "el-icon-delete"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDelete(category)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ])
          ])
        : _c("EmptyList")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(" Network Name ")]),
        _c("th", { staticClass: "text-center" }, [_vm._v(" Sites ")]),
        _c("th", { staticClass: "fixed-right-column text-center" }, [
          _vm._v("Actions")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }